// Shared helpers for high-impact FX economic events.
export const pairCcy = (pair) => [pair.slice(0, 3), pair.slice(3)];

export function buildNextEvt(events) {
  const now = Date.now();
  const next = {};
  (events || []).forEach((e) => {
    if (!e.currency || e.currency === "All") return;
    const t = new Date(e.date).getTime();
    if (isNaN(t)) return;
    if (t > now && (!next[e.currency] || t < new Date(next[e.currency].date).getTime())) {
      next[e.currency] = { date: e.date, title: e.title, currency: e.currency };
    }
  });
  return next;
}

export function soonestEvent(nextEvt, pair) {
  const [b, q] = pairCcy(pair);
  let best = null;
  [nextEvt[b], nextEvt[q]].forEach((e) => {
    if (e && (!best || new Date(e.date).getTime() < new Date(best.date).getTime())) best = e;
  });
  return best;
}

export const minsUntil = (iso) => (new Date(iso).getTime() - Date.now()) / 60000;

// Returns the upcoming event if it lands within `mins` minutes, else null.
export function eventWithin(nextEvt, pair, mins = 60) {
  const e = soonestEvent(nextEvt, pair);
  if (e && minsUntil(e.date) <= mins && minsUntil(e.date) > 0) return e;
  return null;
}
